import React from "react"
import { isEmpty } from '../../../tools/helpers';
import { excludeGroupedTrips } from './gmproMapHelpers';
import Select, { components as selectComponents } from 'react-select';
import DatePickerInputBox from './DatePickerInputBox';
import { ChevronDownIcon } from './HeroIcons';

// Use the Figma's thin heroicons chevron for the select dropdown indicator.
const DropdownIndicator = (props) => (
  <selectComponents.DropdownIndicator {...props}>
    <ChevronDownIcon size={16} style={{ color: '#6E6C71' }} />
  </selectComponents.DropdownIndicator>
);

const renderCompanyOptions = (companies) => {
  let companyOptions = []
  if (!isEmpty(companies)) {
    companyOptions = companies.map((company) => (
      {value: company.id, label: company.name || 'empty name', key: company.id}
    ));
  } 

  return [
    {value: "none", label: "Select company"},
  ...companyOptions
  ]
  
}



  const renderCompanyAddresses = (companyAddresses, allTrips, allGroups, allAsssignedGroups) => {
    let addressOptions = []
    if (!isEmpty(companyAddresses)) {
      addressOptions = companyAddresses.map((address, index) => (
        {value: address, label: address}
      ));
    }

    return [
      {value: "none", label: "Select Address"},
    ...addressOptions
    ]
  };

// Figma: filter inputs are white with a 0.911px rgba(110,108,113,0.3) border,
// ~5px radius, #6E6C71 text, Ubuntu Light (300) — matching the Search/Time/Date
// inputs so every filter shares the same weight.
const customStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    appearance: 'none',
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    border: '0.911px solid rgba(110,108,113,0.3)',
    boxShadow: 'none',
    fontSize: '12px',
    fontWeight: 300,
    color: '#6E6C71',
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#6E6C71"
  }),
  // Figma has no separator line before the chevron.
  indicatorSeparator: () => ({ display: 'none' }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    color: '#6E6C71',
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    fontWeight: 300,
    color: '#6E6C71',
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    fontWeight: 300,
    color: '#6E6C71',
  }),
};


const PassengerMenu = ({
    selectedDate,
    setSelectedDate,
    companies,
    addresses,
    setSelectedAddress,
    selectedAddress,
    setSelectedCompany,
    selectedCompanyRef,
    inboundTrips,
    setInboundTrips,
    outboundTrips,
    setOutboundTrips,
    setInboundGroupedTrips,
    setInboundAssignedGroupedTrips,
    setOutboundGroupedTrips,
    setOutboundAssignedGroupedTrips,
    setSelectedTrips,
    setSelectedGroup,
    setBound, 
    bound,
    allTrips,
    allGroups,
    allAsssignedGroups,
    setShowAssignedTrips,
    setShowGroupedTrips,
    showAssignedTrips,
    showGroupedTrips,
    role,
}) => {


    const handleCompanySelect = (e) => {
        const companyID = e.value;
        setSelectedCompany(companyID);
        setSelectedAddress('None');
        handleAddressChange({value: 'None'})
      };

    const handleAddressChange = (selectedAddress) => {
      const address = selectedAddress.value
      if (address === 'None') {
        setSelectedTrips([]);
        setSelectedGroup([]);
        setInboundTrips([]);
        setOutboundTrips([]);
        setInboundGroupedTrips([]);
        setOutboundGroupedTrips([]);
        setSelectedAddress(address);
        // Keep the chosen trip type (Inbound/Outbound) when the company/address
        // changes — the Trip Type select still shows it, so resetting here only
        // desynced the displayed value from the filter.
        return;
      } else {
        setSelectedAddress(address);
        if (allTrips.hasOwnProperty(address)) {
          // Filter out trips that already belong to a group so re-picking an
          // address never re-surfaces a just-grouped trip as ungrouped (the
          // grouped-trip phantom invariant; allTrips can be stale here).
          const addressGroups = allGroups?.[address] || {};
          const addressAssigned = allAsssignedGroups?.[address] || {};
          setInboundTrips(excludeGroupedTrips(allTrips[address].inbound, addressGroups.inbound, addressAssigned.inbound));
          setOutboundTrips(excludeGroupedTrips(allTrips[address].outbound, addressGroups.outbound, addressAssigned.outbound));
        } else {
          setInboundTrips([]);
          setOutboundTrips([]);
        }
        if (allGroups.hasOwnProperty(address)) {
          setInboundGroupedTrips(allGroups[address].inbound);
          setOutboundGroupedTrips(allGroups[address].outbound);
        }else {
          setInboundGroupedTrips([]);
          setOutboundGroupedTrips([]);
        }

        if (allAsssignedGroups.hasOwnProperty(address)) {
          setInboundAssignedGroupedTrips(allAsssignedGroups[address].inbound);
          setOutboundAssignedGroupedTrips(allAsssignedGroups[address].outbound);
        } else {
          setInboundAssignedGroupedTrips([]);
          setOutboundAssignedGroupedTrips([]);
        }
      }
    };

    return (
        <div className="bg-white p-4 shadow-lg" style={{ borderRadius: '9px' }} >
            <div className='flow-root'>
                {/* Company Select */}
                <div data-testid="company-select" className="inline-block relative text-xs pr-2 selectCompany" style={{ width: '160px' }}>
                <Select
                  options={renderCompanyOptions(companies)}
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  onChange={handleCompanySelect}
                  placeholder={"Select Company"}
                />
              </div>
              <div className="inline-block relative text-xs pr-2 selectDate" style={{ width: '160px' }}>
                <DatePickerInputBox
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </div>
                {/* Address Select */}
                <div data-testid="address-select" className="inline-block relative text-xs pr-2 selectAddress" style={{ width: '160px' }}>
                  <Select 
                    options={renderCompanyAddresses(addresses, allTrips, allGroups, allAsssignedGroups)}
                    styles={customStyles}
                  components={{ DropdownIndicator }}
                    onChange={handleAddressChange}
                    placeholder={"Select Address"}
                    value={(selectedAddress == "None") ? {value: "None", label: "Select Address"} : {value: selectedAddress, label: selectedAddress}}
                  />
                </div>
                {/* Trip Type Select */}
                <div data-testid="bound-select" className="inline-block relative text-xs tripType" style={{ width: '160px' }}>
                  <Select
                    options={[{value: "Inbound", label: "Inbound"},{value: "Outbound", label: "Outbound"}]}
                    styles={customStyles}
                  components={{ DropdownIndicator }}
                    onChange={(e) => setBound(e.value)}
                    placeholder={"Inbound"}
                  />
                </div>
                {
                  (role != "fleetmanager") &&
                  <div className='flow-root mt-2 flex-row align-center justify-center filters'>
                    <div className={ showGroupedTrips ? "inline-block relative w-32 h-6 text-sm p-1 text-gray-800 content-center hover:text-gray-500 ": "inline-block relative w-32 h-6 text-sm p-1  text-gray-500 content-center hover:text-gray-800 "}
                        onClick={() => {setShowGroupedTrips(!showGroupedTrips)}}
                        style={{userSelect: 'none'}}>
                        <i id="show-hide-grouped"  className={ showGroupedTrips ? "fas fa-eye m-2" : "fas fa-eye-slash m-2"} ></i>
                        <div className={"align-middle inline-block pointer-events-none font-medium"}>Grouped</div>
                    </div>
                    <div className={ showAssignedTrips ? "inline-block relative w-32 h-6 text-sm p-1 text-gray-800 content-center hover:text-gray-500 ": "inline-block relative w-32 h-6 text-sm p-1  text-gray-500 content-center hover:text-gray-800 "}
                     onClick={()=>{setShowAssignedTrips(!showAssignedTrips)}}
                     style={{userSelect: 'none'}}>
                        <i id="show-hide-assigned" className={ showAssignedTrips ? "fas fa-eye m-2 " : "fas fa-eye-slash m-2"}></i>
                        <div className={"align-middle inline-block pointer-events-none font-medium"}>Assigned</div>
                    </div>
                  </div>
                }
            </div>
        </div>
    )
}

export default PassengerMenu